import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';

import { lookupState, currentRmaState, accountState, loadingState } from 'state/atoms';
import { lookupViewSelector } from 'state/selectors';
import { Container } from 'components/layout';
import { StartRmaModal } from 'components/modals';
import FadeContent from 'components/FadeContent';

import { LOOKUP_UI_INITIAL_STATE, CLONE_FROM_PARAM, NEW_CASE_PARAM } from 'utils/constants';

import { LookupActions, Title } from './styledComponents';
import ViewDetails from './subcomponents/ViewDetails';
import StartOver from './subcomponents/StartOver';
import { LookupView } from './LookupView';

export const NewCaseSearch = () => {
  const { search } = useLocation();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const { items } = useRecoilValue(currentRmaState);
  const accountData = useRecoilValue(accountState);
  const viewState = useRecoilValue(lookupViewSelector);
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);
  const setLoading = useSetRecoilState(loadingState);

  const { lookupResults } = currentLookupState;

  // If the item is being cloned, fill lookup state with the cloned item data
  useEffect(() => {
    const clonedSerialNumber = new URLSearchParams(search).get(CLONE_FROM_PARAM);

    if (clonedSerialNumber && lookupResults.length) {
      const itemToClone =
        items.find(({ serialNumber }) => serialNumber === clonedSerialNumber) || {};

      setLookupState({
        ...currentLookupState,
        failureCode: {
          touched: true,
          value: itemToClone.failureCode || '',
        },
        serviceActivity: {
          touched: true,
          value: itemToClone.serviceActivity || '',
        },
        failureDescription: {
          touched: true,
          value: itemToClone.failureDescription || '',
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookupResults]);

  useEffect(() => {
    const isNewCase = new URLSearchParams(search).get(NEW_CASE_PARAM) === 'true';

    if (isNewCase && items.length) {
      setIsConfirmationModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoading(!accountData.accountId);
  }, [accountData, setLoading]);

  return (
    <Container>
      <Title>New RMA Case Item</Title>
      <FadeContent>
        <LookupView status={viewState} lookupResults={lookupResults} />
        <LookupActions withBorder={viewState !== LOOKUP_UI_INITIAL_STATE}>
          <ViewDetails />
          <StartOver />
        </LookupActions>
      </FadeContent>
      <StartRmaModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
      />
    </Container>
  );
};
